/*
 * @Author: 小周
 * @Date: 2023-09-06 12:01:35
 * @LastEditTime: 2024-06-12 11:32:17
 * @LastEditors: MrZHLF
 * @Description:
 */
import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import store from './redux/index'
import './index.scss'
import App from './App'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <Provider store={store}>
    <App />
  </Provider>
)
